<template>
  <v-dialog
    v-model="show"
    persistent
    width="750"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <v-card :loading="isLoading" :disabled="isLoading">
      <v-card-title>
        <div>Perpanjang Jadwal Kelas untuk {{ classroom.name }} ?</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <p>
          Proses ini akan men-generate jadwal-jadwal kelas baru bedasarkan
          tanggal pertemuan kelas terakhir: {{ classroom.end_date }}
        </p>
        <v-form ref="form">
          <div class="label mb-2">Extension Date</div>
          <v-menu
            ref="extendDateMenu"
            v-model="extendDateMenu"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="extendDate"
                :rules="[validationRules.required]"
                placeholder="Select class extension date"
                prepend-icon="mdi-calendar"
                solo
                flat
                outlined
                dense
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="extendDate"
              :min="classroom.end_date"
              @change="$refs.extendDateMenu.save(extendDate)"
            ></v-date-picker>
          </v-menu>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn depressed outlined @click="show = false">Cancel</v-btn>
        <v-btn
          depressed
          color="primary"
          :disabled="isLoading"
          @click="clickConfirm"
          >Confirm</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ExtendClassroomScheduleDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    classroom: {
      type: Object,
      required: true,
    },
    submitApi: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      extendDate: null,
      extendDateMenu: false,
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'classroom/isExtendSchedulesLoading',
    }),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    ...mapActions({ extendSchedules: 'classroom/extendSchedules' }),
    async clickConfirm() {
      if (this.submitApi) {
        const err = await this.extendSchedules({
          id: this.classroom.id,
          extend_date: this.extendDate,
        })
        if (!err) {
          this.show = false
          this.$emit('submit')
        }
      } else {
        this.$emit('confirm', {
          extendDate: this.extendDate,
        })
      }
    },
  },
}
</script>
